import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const handlerStack: VoidFunction[] = [];

export const handleNativeBack = (): void => {
  const handler = handlerStack.at(-1);
  if (handler) {
    handler();
    return;
  }
  void App.minimizeApp();
};

// Any backButton listener replaces Android's default, which finishes the activity.
export const startNativeBackButton = (): void => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  void App.addListener('backButton', handleNativeBack);
};

export const registerNativeBackHandler = (handler: VoidFunction): VoidFunction => {
  handlerStack.push(handler);

  return () => {
    const index = handlerStack.lastIndexOf(handler);
    if (index >= 0) {
      handlerStack.splice(index, 1);
    }
  };
};
